var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed view"},[_c('injected-chart',{attrs:{"config":{url: _vm.$route.fullPath, kpis: []},"title":true,"visible":true,"blank":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }